// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { Lightbox } from "lightbox3"
import "./controllers"

// Lightbox3 is a document-level delegated viewer. Its initializer is a
// singleton, so it is safe to call once for the initial page and again after
// Turbo replaces the document or a frame's gallery content.
const initializeLightbox = () => Lightbox.init()

initializeLightbox()
document.addEventListener("turbo:load", initializeLightbox)
